import { createBrowserRouter } from 'react-router';
import { AdminLayout } from './components/AdminLayout';
import { RouteError } from './components/RouteError';
import { LoginPage, SetupTwoFactorPage, VerifyCodePage } from './pages/AuthPages';
import { OverviewPage } from './pages/OverviewPage';
import { TenantsPage } from './pages/TenantsPage';
import { ErrorsPage } from './pages/ErrorsPage';
import { AgentsPage } from './pages/AgentsPage';
import { SalesPage } from './pages/SalesPage';
import { PricesPage } from './pages/PricesPage';
import { AlertsPage } from './pages/AlertsPage';
import { LeadsPage } from './pages/LeadsPage';
import { CommsPage } from './pages/CommsPage';
import { StatsPage } from './pages/StatsPage';
import { BifiStatsPage } from './pages/BifiStatsPage';
import { TeamPage } from './pages/TeamPage';
import { PartnersPage, SellersPage } from './pages/SellersPage';
import { ProspectsPage } from './pages/ProspectsPage';
import { CommissionsPage } from './pages/CommissionsPage';
import { PortalClientsPage, PortalCommissionsPage, PortalHomePage, PortalProspectsPage, PortalTeamPage } from './pages/PortalPages';

export const router = createBrowserRouter([
  {
    errorElement: <RouteError />,
    children: [
      { path: '/ingresar', element: <LoginPage /> },
      { path: '/ingresar/codigo', element: <VerifyCodePage /> },
      { path: '/activar-2fa', element: <SetupTwoFactorPage /> },
      {
        element: <AdminLayout />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: 'clientes', element: <TenantsPage /> },
          { path: 'errores', element: <ErrorsPage /> },
          { path: 'agentes', element: <AgentsPage /> },
          { path: 'ventas', element: <SalesPage /> },
          { path: 'precios', element: <PricesPage /> },
          { path: 'avisos', element: <AlertsPage /> },
          { path: 'consultas', element: <LeadsPage /> },
          { path: 'comunicacion', element: <CommsPage /> },
          { path: 'estadisticas', element: <StatsPage /> },
          { path: 'bifi', element: <BifiStatsPage /> },
          { path: 'equipo', element: <TeamPage /> },
          { path: 'vendedores', element: <SellersPage /> },
          { path: 'partners', element: <PartnersPage /> },
          { path: 'mis-clientes', element: <PortalClientsPage /> },
          { path: 'prospectos', element: <ProspectsPage /> },
          { path: 'comisiones', element: <CommissionsPage /> },
          { path: 'mi-panel', element: <PortalHomePage /> },
          { path: 'mis-prospectos', element: <PortalProspectsPage /> },
          { path: 'mis-comisiones', element: <PortalCommissionsPage /> },
          { path: 'mi-equipo', element: <PortalTeamPage /> },
        ],
      },
    ],
  },
]);
